<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">I would like to dedicate this book to two people who were instrumental in encouraging my interest in the Civil War and particularly the events in Missouri.</p>
<br/><p style="text-indent:00em;">First, I would like to thank my good old buddy, Steve Wiechens, who shared my passion and curiosity about those traumatic events that shaped the history of our state. Rest in peace, brother.</p>
<br/><p style="text-indent:00em;">Secondly, I need to remember my departed sister, Patricia (‘Padi’) Drennen that fed my ‘C.W.’ cravings by sending me books from Missouri back in the 1990s that I could not get back in the East and the many historical discussions we had. Miss you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?617fd021